import { type UseGetQueryOptions } from "@src/appV2/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useQuery } from "@tanstack/react-query";

import { fetchDocumentDistributionUrl } from "./fetchDocumentDistributionUrl";

interface UseGetDocumentDistributionUrlParams {
  documentId: string;
}

export function getDocumentDistributionUrlQueryKey(
  params: UseGetDocumentDistributionUrlParams
): readonly unknown[] {
  return ["document-distribution-url", params.documentId] as const;
}

export function useGetDocumentDistributionUrl(
  params: UseGetDocumentDistributionUrlParams,
  options?: UseGetQueryOptions<string>
) {
  return useQuery({
    queryKey: getDocumentDistributionUrlQueryKey(params),
    queryFn: async () => await fetchDocumentDistributionUrl({ documentId: params.documentId }),
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_DOCUMENT_DISTRIBUTION_URL_FAILURE,
    },
    ...options,
  });
}
